/**
 * @module lib/commercial/keytar/registered/template
 */
import Template, { BLOCKOUT_TYPES, shouldShowTeaserRendering } from "lib/commercial/keytar/Template";
import tgamConfig from "config/tgam";
import { setUpTeaserView } from "lib/commercial/keytar/common/teaser";
import { setUpModalView } from "lib/commercial/keytar/common/takeover";
import isNil from "lodash/isNil";

/** @type {String} */
const wallType = "meteredPaywall";
let leaveSection = ["top-furniture-area"];
let appendClasses = ["header-nav"];
let blockoutType = BLOCKOUT_TYPES.HEADER_NAV_ACCESSIBLE; // responsive modal displayed

if (tgamConfig.meta.isStoryInteractivePage) {
  blockoutType = BLOCKOUT_TYPES.EVERYTHING; // responsive modal displayed
  leaveSection = [];
  appendClasses = [];
}

const showTeaserRendering = shouldShowTeaserRendering();
if (showTeaserRendering) {
  blockoutType = BLOCKOUT_TYPES.PREVIEW;
}

const props = {
  blockoutType,
  darwinRenderKey: wallType,
  /**
   * @method render
   * @description Always render the paywall template.
   * @returns {Promise<Boolean>} true if rendered
   */
  render() {
    let { darwinTemplate, viewType, paragraphs } = this.darwinRendering();
    if (isNil(viewType) && showTeaserRendering) {
      this.updateTeaserAnalytics(paragraphs);
      viewType = "teaser";
    }
    if (viewType === "teaser") {
      const contentType = this.parentContext.contentType;
      setUpTeaserView(wallType, darwinTemplate, paragraphs, contentType);
    } else { // modal view via Darwin test or something not "teaser"
      setUpModalView(wallType, darwinTemplate, ["subscriber", "subscriber-modal"], leaveSection, appendClasses);
    }
    return Promise.resolve(true);
  }
};

export default new Template(props);
